// شارة إحصائية بلون + رقم — تستبدل النص الملوّن البسيط في هيدر المنحنى.
export const StatPill = ({ tone, label, value }) => (
  <div className="inline-flex items-center gap-2 rounded-full border border-border/50 bg-background/70 px-3 py-1.5 shadow-neu-sm">
    <span className={`h-2.5 w-2.5 rounded-full ${tone}`} style={{ boxShadow: "inset 0 1px 0 rgba(255,255,255,0.5), 0 0 6px currentColor" }} />
    <span className="text-[12px] font-bold text-muted-foreground">{label}</span>
    <span className="num font-mono text-sm font-black text-foreground">{value}</span>
  </div>
);
